import { Col, Collapse, Row, Spin } from "antd";
import { useEffect, useState } from "react";
import { useDealer } from "../../../../../../tools/api";
import { complexDigitToman, convertToJalaliWithoutTime, convertToJalaliWithTime, formatTime } from "../../../../../../tools/tools";

const ProfileInfo = ({ purchase = {}, styles }) => {
	console.log(purchase);
	const { querySPPurchaseVProfileDealerById, querySPPurchaseBySPPurchaseId, queryProfileSPurchaseBySPPurchaseId, queryIMEI, queryLACByMSISDN } =
		useDealer();
	const [profile, setProfile] = useState({
		purchase: {},
		prof: {},
		dealer: {},
		imeiQuery: {},
		lat: [],
		isloading: false,
	});
	useEffect(() => {
		const callServices = async () => {
			// const resQueryMIEI = await queryIMEI({ msisdn: purchase?.inT_MSISDN });
			// setProfile((profile) => ({
			// 	...profile,
			// 	// dealer: resDealer || {},
			// 	prof: resProfilePurchase || {},
			// 	purchase: resPurchase || {},
			// 	imeiQuery: resQueryMIEI,
			// }));
		};
		if (purchase?.guD_PurchaseProductId) {
			callServices();
		}
	}, [purchase]);
	const handleChange = async (item) => {
		if (item?.includes("dealerInfo")) {
			const resDealer = await querySPPurchaseVProfileDealerById(purchase?.guD_PurchaseProductId);
			setProfile((profile) => ({
				...profile,
				dealer: resDealer || {},
			}));
		}
		if (item?.includes("purchaseInfo")) {
			const resPurchase = await querySPPurchaseBySPPurchaseId(purchase?.guD_PurchaseProductId);
			setProfile((profile) => ({
				...profile,
				purchase: resPurchase || {},
			}));
		}
		if (item?.includes("simcardInfo")) {
			const resProfilePurchase = await queryProfileSPurchaseBySPPurchaseId(purchase?.guD_PurchaseProductId);
			setProfile((profile) => ({
				...profile,
				prof: resProfilePurchase || {},
			}));
		}
		if (item?.includes("networkInfo")) {
			const resQueryMIEI = await queryIMEI({ msisdn: purchase?.inT_MSISDN });
			const resQueryLACByMSISDN = await queryLACByMSISDN(purchase?.inT_MSISDN);
			setProfile((profile) => ({
				...profile,
				imeiQuery: resQueryMIEI,
				lat: resQueryLACByMSISDN,
			}));
		}
	};
	return (
		<>
			<div className={styles.purchase_detail}>
				{/* <Collapse /> */}
				<Collapse
					defaultActiveKey={[0]}
					onChange={handleChange}
					items={[
						{
							key: "dealerInfo",
							label: <div className={styles.page_title}>اطلاعات نماینده / شرکت</div>,
							children: (
								<>
									{profile.isloading ? (
										<div style={{ height: "20rem", display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center" }}>
											{" "}
											<Spin />
										</div>
									) : (
										<div className={styles.page_body}>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نام نماینده:</div>
													<div className={styles.value}>{profile?.dealer?.firstName || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نام خانوادگی نماینده:</div>
													<div className={styles.value}>{profile?.dealer?.lastName || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>کدملی نماینده:</div>
													<div className={styles.value}>{profile?.dealer?.stR_CertNo || "-"}</div>
												</Col>
											</Row>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نام شرکت:</div>
													<div className={styles.value}>{profile?.dealer?.stR_FName || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>شناسه ملی شرکت:</div>
													<div className={styles.value}>{profile?.dealer?.stR_CertNo || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>شماره ثبت شرکت:</div>
													<div className={styles.value}>{profile?.dealer?.inT_IdentityNo || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>تاریخ ثبت شرکت:</div>
													<div className={styles.value}>{convertToJalaliWithoutTime(profile?.dealer?.dtE_BirthDate) || "-"}</div>
												</Col>
											</Row>
										</div>
									)}
								</>
							),
						},
						{
							key: "purchaseInfo",
							label: <div className={styles.page_title}>اطلاعات سفارش</div>,
							children: (
								<>
									{profile.isloading ? (
										<div style={{ height: "20rem", display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center" }}>
											{" "}
											<Spin />
										</div>
									) : (
										<div className={styles.page_body}>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>درگاه خرید:</div>
													<div className={styles.value}>{profile?.purchase?.stR_ApplicationName}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>تاریخ خرید:</div>
													<div className={styles.value}>
														{(convertToJalaliWithTime(profile?.purchase?.dtE_PurchaseDate) + " - " + profile?.purchase?.dtE_PurchaseDate &&
															formatTime(new Date(profile?.purchase?.dtE_PurchaseDate))) ||
															"-"}
													</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نام بسته اولیه(آغازین):</div>
													<div className={styles.value}>{profile?.purchase?.packagename || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>کانال فروش:</div>
													<div className={styles.value}></div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>وضعیت خرید:</div>
													<div className={styles.value}>{profile?.purchase?.stR_PurchaseState || "-"}</div>
												</Col>
											</Row>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>روش دریافت:</div>
													<div className={styles.value}>{profile?.purchase?.stR_MethodOfReceiptType || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>شاهکار:</div>
													<div className={styles.value}>{profile?.purchase?.shahkarId ? <>دارد</> : <>ندارد</>}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نام کاربر:</div>
													<div className={styles.value}>{profile?.purchase?.userName || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>مبلغ پرداختی:</div>
													<div className={styles.value}>
														{profile?.purchase?.inT_PurchaseAmount == 0
															? profile?.purchase?.paidtype
															: complexDigitToman(profile?.purchase?.inT_PurchaseAmount) || "-"}
													</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>کد تخفیف:</div>
													<div className={styles.value}>{profile?.purchase?.discountcode || "-"}</div>
												</Col>
											</Row>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>درصد تخفیف:</div>
													<div className={styles.value}>{profile?.purchase?.discountPercent || "-"}</div>
												</Col>
											</Row>
										</div>
									)}
								</>
							),
						},
						{
							key: "simcardInfo",
							label: <div className={styles.page_title}>اطلاعات سیم کارت</div>,
							children: (
								<>
									{profile.isloading ? (
										<div style={{ height: "20rem", display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center" }}>
											{" "}
											<Spin />
										</div>
									) : (
										<div className={styles.page_body}>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>شماره کیت:</div>
													<div className={styles.value}>{profile?.dealer?.stR_ICCID?.slice(10, 19) || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>تاریخ خرید:</div>
													<div className={styles.value} dir="ltr">
														{/* {convertToJalaliWithTime(profile?.dealer?.dtE_PurchaseDate) || "-"} - {formatTime(new Date(profile?.dealer?.dtE_PurchaseDate)) || "-"} */}
														{(profile?.dealer?.dtE_PurchaseDate && formatTime(new Date(profile?.dealer?.dtE_PurchaseDate))) || "-"}
													</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نوع سیم کارت:</div>
													<div className={styles.value}>{profile?.dealer?.bundleType ? <>دائمی</> : <>اعتباری</> || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label} dir="ltr">
														:PIN 1
													</div>
													<div className={styles.value} dir="ltr">
														{profile?.dealer?.stR_PIN1 || "-"}
													</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>PIN 2:</div>
													<div className={styles.value} dir="ltr">
														{profile?.dealer?.stR_PIN2 || "-"}
													</div>
												</Col>
											</Row>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>PUK 1:</div>
													<div className={styles.value} dir="ltr">
														{profile?.dealer?.stR_PUK1 || "-"}
													</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>PUK 2:</div>
													<div className={styles.value} dir="ltr">
														{profile?.dealer?.stR_PUK2 || "-"}
													</div>
												</Col>
											</Row>
										</div>
									)}
								</>
							),
						},
						{
							key: "networkInfo",
							label: <div className={styles.page_title}>اطلاعات شبکه</div>,
							children: (
								<>
									{profile.isloading ? (
										<div style={{ height: "20rem", display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center" }}>
											{" "}
											<Spin />
										</div>
									) : (
										<div className={styles.page_body}>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>آخرین IMEI:</div>
													<div className={styles.value}>{profile?.imeiQuery?.imei}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>آخرین مصرف دیتا:</div>
													<div className={styles.value}>
														<span dir="ltr">{convertToJalaliWithTime(profile?.imeiQuery?.lastDataUsageDate, "/") || "-"}</span>
													</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>آخرین مصرف مکالمه:</div>
													<div className={styles.value}>
														<span dir="ltr">{convertToJalaliWithTime(profile?.imeiQuery?.lastVoiceUsageDate, "/") || "-"}</span>
													</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>آخرین مصرف پیامک:</div>
													<div className={styles.value}>
														<span dir="ltr">{convertToJalaliWithTime(profile?.imeiQuery?.lastSMSUsageDate, "/")}</span>
													</div>
												</Col>
											</Row>
											<Row>
												{profile?.lat?.map((item) => (
													<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
														<div className={styles.label}>موقیت مکانی(استان):</div>
														<div className={styles.value}>
															<span dir="ltr">
																{item.province}
																{/* - {item.city} */}
															</span>
														</div>
													</Col>
												))}
											</Row>
										</div>
									)}
								</>
							),
						},
					]}
				/>
			</div>
		</>
	);
};

export default ProfileInfo;
